import idx from "idx"

/**
 * transform - manipulate data from the graphql query
 * @param {object} careers
 * @returns {object}
 */
function transform(careers) {
  const photos = careers.photoGrid
    ? careers.photoGrid.map(photo => {
        return {
          fluid: idx(photo, _ => _.fluid),
          title: idx(photo, _ => _.title)
        }
      })
    : []

  const title = idx(careers, _ => _.title)
  const headline = idx(careers, _ => _.headline)
  const gridHeadline = idx(careers, _ => _.gridHeadline)
  const headerCopy = idx(careers, _ => _.headerCopy.childMarkdownRemark.html)
  const gridCopy = idx(careers, _ => _.gridCopy.childMarkdownRemark.html)

  return {
    photos,
    title,
    headline,
    gridHeadline,
    headerCopy,
    gridCopy
  }
}

export default { transform }
